import { useState } from "react";
import { P, FF, inputBase } from "../../styles/tokens";
import { fmt } from "../../utils/format";
import { MESES } from "../../constants/months";
import { CATS_LIST, catIcon, catColor } from "../../constants/categories";
import { getMsiCuotasMes } from "../../utils/gastos";
import { Pill } from "../ui";
import { reportar } from "../../utils/reportar";

export default function MsiSection({ msiCompras, setMsiCompras, toggleMsiPago, activeMonth, mobile, cuentas = [] }) {
  const [showForm, setShowForm] = useState(false);
  const [confirmingId, setConfirmingId] = useState(null);
  const hoyISO = new Date().toISOString().slice(0, 10);
  const hace24 = (() => { const d = new Date(); d.setMonth(d.getMonth() - 24); return d.toISOString().slice(0, 10); })();
  const [draft, setDraft] = useState({ concepto:"", cat:"", totalCompra:"", meses:12, fechaCompra: hoyISO, cuentaId:"" });
  const currentYear = new Date().getFullYear();
  const currentMonthIdx = new Date().getMonth();
  const cuotaMes = getMsiCuotasMes(activeMonth, msiCompras, currentYear);
  const totalCuotasMes = cuotaMes.reduce((s,c) => s + c.cuota, 0);
  const tdcCuentas = cuentas.filter(c => c.tipo === "crédito");

  const addCompra = () => {
    if (!draft.totalCompra || Number(draft.totalCompra) <= 0) return;
    if (!draft.fechaCompra) return;
    const fecha = new Date(draft.fechaCompra + "T00:00:00");
    const mesIni = fecha.getMonth();
    const anioIni = fecha.getFullYear();
    const numMeses = Number(draft.meses);
    const cuota = Math.round(Number(draft.totalCompra) / numMeses);
    // Auto-marcar cuotas ya pasadas (anteriores al mes/año actual) como pagadas
    const pagos = {};
    const startAbs = anioIni * 12 + mesIni;
    const currentAbs = currentYear * 12 + currentMonthIdx;
    for (let offset = 0; offset < numMeses; offset++) {
      const abs = startAbs + offset;
      if (abs < currentAbs) {
        const mIdx = abs % 12;
        pagos[mIdx] = { pagado: true, montoPagado: cuota };
      }
    }
    setMsiCompras([...msiCompras, {
      id:crypto.randomUUID(), concepto:draft.concepto||"Compra a meses", cat:draft.cat||"Otros",
      totalCompra:Number(draft.totalCompra), meses:numMeses, mesInicio:mesIni, anioInicio:anioIni,
      cuentaId:draft.cuentaId||null, pagos,
    }]);
    setDraft({ concepto:"", cat:"", totalCompra:"", meses:12, fechaCompra: hoyISO, cuentaId:"" });
    setShowForm(false);
  };
  const deleteMsi = (id) => setMsiCompras(msiCompras.filter(c => c.id !== id));
  const togglePago = (compraId, mes) => {
    const compra = msiCompras.find(c => c.id === compraId);
    if (!compra) return;
    const prev = (compra.pagos||{})[mes] || {};
    const cuota = Math.round(compra.totalCompra / compra.meses);
    setMsiCompras(msiCompras.map(c => {
      if (c.id !== compraId) return c;
      return { ...c, pagos: { ...c.pagos, [mes]: { ...prev, pagado: !prev.pagado, montoPagado: prev.pagado ? null : cuota } } };
    }));
    if (prev.pagoId && toggleMsiPago) {
      toggleMsiPago(prev.pagoId, compraId).catch(reportar("marcar cuota MSI"));
    }
  };
  const catData = CATS_LIST.find(c => c.id === draft.cat);
  const draftCuota = draft.totalCompra > 0 && draft.meses > 0 ? Math.round(Number(draft.totalCompra) / Number(draft.meses)) : 0;
  const getCuentaNombre = (id) => { const c = cuentas.find(ct => ct.id === id); return c ? c.nombre : ""; };

  return (
    <div style={{ marginBottom:14, borderRadius:16, border:`1.5px solid ${P.border}`, overflow:"hidden", background:P.surface }}>
      <div style={{ padding:"14px 20px", background:P.fijos.pastel, borderBottom:`1.5px solid ${P.fijos.tint}`,
        display:"flex", justifyContent:"space-between", alignItems:"center" }}>
        <div style={{ display:"flex", alignItems:"center", gap:10 }}>
          <span style={{ fontSize:16 }}>💳</span>
          <span style={{ fontWeight:700, fontSize:14, color:P.fijos.text, fontFamily:FF }}>Compras a Meses Sin Intereses</span>
          {cuotaMes.length > 0 && (
            <span style={{ fontSize:11, fontWeight:700, background:P.fijos.tint, color:P.fijos.text, borderRadius:99, padding:"2px 9px" }}>
              {cuotaMes.length} activa{cuotaMes.length!==1?"s":""}
            </span>
          )}
        </div>
        <span style={{ fontWeight:900, fontSize:16, color:P.fijos.text, fontFamily:FF }}>{totalCuotasMes > 0 ? fmt(totalCuotasMes) : "—"}</span>
      </div>
      <div style={{ padding:"12px 20px 18px" }}>
        {cuotaMes.length > 0 && (
          <div style={{ marginBottom:16 }}>
            <div style={{ fontSize:10, fontWeight:700, color:P.textXs, fontFamily:FF, textTransform:"uppercase", letterSpacing:"0.08em", marginBottom:10 }}>Cuotas de {MESES[activeMonth]}</div>
            {cuotaMes.map(c => (
              <div key={c.id} style={{ display:"flex", alignItems:"center", gap:8, padding:"8px 0", borderBottom:`1px solid ${P.border}` }}>
                <div style={{ width:28, height:28, borderRadius:9, background:`${catColor(c.cat)}18`, display:"flex", alignItems:"center", justifyContent:"center", fontSize:13, flexShrink:0 }}>{catIcon(c.cat)}</div>
                <div style={{ flex:1, minWidth:0 }}>
                  <div style={{ fontSize:13, fontWeight:600, color:P.text, fontFamily:FF, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>{c.concepto}</div>
                  <div style={{ fontSize:10, color:P.textXs, fontFamily:FF }}>Cuota {c.cuotaN} de {c.meses} · total {fmt(c.totalCompra)}{c.cuentaId ? ` · ${getCuentaNombre(c.cuentaId)}` : ""}</div>
                </div>
                <span style={{ fontSize:14, fontWeight:900, color:P.fijos.text, fontFamily:FF, flexShrink:0 }}>{fmt(c.cuota)}</span>
              </div>
            ))}
          </div>
        )}
        {msiCompras.length > 0 && (
          <div style={{ marginBottom:14 }}>
            <div style={{ fontSize:10, fontWeight:700, color:P.textXs, fontFamily:FF, textTransform:"uppercase", letterSpacing:"0.08em", marginBottom:8 }}>Todas las compras a meses</div>
            {msiCompras.map(c => {
              const cuota = Math.round(c.totalCompra / c.meses);
              const pagosMarcados = Object.values(c.pagos||{}).filter(p=>p.pagado).length;
              const mesFinNombre = c.mesInicio + c.meses - 1 < 12 ? MESES[c.mesInicio + c.meses - 1] : `mes ${c.mesInicio + c.meses}`;
              return (
                <div key={c.id} style={{ display:"flex", alignItems:"center", gap:10, padding:"8px 12px", borderRadius:12, background:P.bg, marginBottom:6, border:`1.5px solid ${P.border}` }}>
                  <div style={{ width:26, height:26, borderRadius:8, background:`${catColor(c.cat)}18`, display:"flex", alignItems:"center", justifyContent:"center", fontSize:12, flexShrink:0 }}>{catIcon(c.cat)}</div>
                  <div style={{ flex:1, minWidth:0 }}>
                    <div style={{ fontSize:12, fontWeight:700, color:P.text, fontFamily:FF }}>{c.concepto}</div>
                    <div style={{ fontSize:10, color:P.textXs, fontFamily:FF }}>
                      {fmt(cuota)}/mes · {pagosMarcados}/{c.meses} pagados · hasta {mesFinNombre}
                      {c.cuentaId ? ` · ${getCuentaNombre(c.cuentaId)}` : ""}
                    </div>
                    <div style={{ height:3, background:P.fijos.tint, borderRadius:99, marginTop:4, overflow:"hidden" }}>
                      <div style={{ height:"100%", borderRadius:99, background:P.fijos.mid, width:`${(pagosMarcados/c.meses)*100}%`, transition:"width .4s" }} />
                    </div>
                  </div>
                  <span style={{ fontSize:13, fontWeight:900, color:P.fijos.text, fontFamily:FF, flexShrink:0 }}>{fmt(c.totalCompra)}</span>
                  {confirmingId === c.id ? (
                    <div style={{ display:"flex", gap:4, alignItems:"center" }}>
                      <span style={{ fontSize:11, fontWeight:600, color:"#991B1B" }}>¿Seguro?</span>
                      <button onClick={()=>{ deleteMsi(c.id); setConfirmingId(null); }}
                        aria-label="Confirmar eliminar"
                        style={{ width:44, height:44, borderRadius:12, border:"1.5px solid #FECACA", background:"#FEF2F2", color:"#DC2626", fontSize:13, fontWeight:700, cursor:"pointer", display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0 }}>✓</button>
                      <button onClick={()=>setConfirmingId(null)}
                        aria-label="Cancelar"
                        style={{ width:44, height:44, borderRadius:12, border:"1.5px solid #E5E7EB", background:"#F3F4F6", color:"#6B7280", fontSize:13, fontWeight:700, cursor:"pointer", display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0 }}>✕</button>
                    </div>
                  ) : (
                    <button onClick={()=>setConfirmingId(c.id)} style={{ width:44, height:44, borderRadius:12, border:`1.5px solid ${P.border}`, background:"transparent", color:P.textXs, cursor:"pointer", fontSize:13, display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0 }}>×</button>
                  )}
                </div>
              );
            })}
          </div>
        )}
        {showForm ? (
          <div style={{ padding:14, background:P.fijos.pastel, borderRadius:14, border:`1.5px solid ${P.fijos.tint}` }}>
            <div style={{ fontSize:12, fontWeight:700, color:P.fijos.text, fontFamily:FF, marginBottom:12 }}>Nueva compra a meses</div>
            <div style={{ display:"grid", gridTemplateColumns:mobile?"1fr":"1fr 1fr", gap:10, marginBottom:10 }}>
              <div>
                <div style={{ fontSize:10, color:P.textXs, fontFamily:FF, marginBottom:4 }}>Descripción</div>
                <input value={draft.concepto} onChange={e=>setDraft({...draft,concepto:e.target.value})} placeholder="Ej: iPhone, Laptop…" style={{ ...inputBase, background:P.surface, fontSize:13 }} />
              </div>
              <div>
                <div style={{ fontSize:10, color:P.textXs, fontFamily:FF, marginBottom:4 }}>Categoría</div>
                <select value={draft.cat} onChange={e=>setDraft({...draft,cat:e.target.value})} style={{ ...inputBase, background:P.surface, fontSize:12, color:catData?catData.color:P.textSm }}>
                  <option value="">Categoría…</option>
                  {CATS_LIST.map(c=><option key={c.id} value={c.id}>{c.icon} {c.id}</option>)}
                </select>
              </div>
              <div>
                <div style={{ fontSize:10, color:P.textXs, fontFamily:FF, marginBottom:4 }}>Total de la compra</div>
                <div style={{ position:"relative" }}>
                  <span style={{ position:"absolute", left:9, top:"50%", transform:"translateY(-50%)", color:P.textXs, fontSize:11 }}>$</span>
                  <input type="number" inputMode="decimal" min="0" value={draft.totalCompra} onChange={e=>setDraft({...draft,totalCompra:e.target.value})} placeholder="0"
                    style={{ ...inputBase, paddingLeft:22, fontWeight:900, background:P.surface, fontSize:14, color:P.fijos.text }} />
                </div>
              </div>
              <div>
                <div style={{ fontSize:10, color:P.textXs, fontFamily:FF, marginBottom:4 }}>Tarjeta de crédito</div>
                <select value={draft.cuentaId} onChange={e=>setDraft({...draft,cuentaId:e.target.value})} style={{ ...inputBase, background:P.surface, fontSize:12 }}>
                  <option value="">Seleccionar TDC…</option>
                  {tdcCuentas.map(c=><option key={c.id} value={c.id}>{c.nombre}{c.banco ? ` · ${c.banco}` : ""}</option>)}
                </select>
              </div>
              {/* minWidth:0 evita que el grid cell desborde por el min-width intrínseco del input date en iOS */}
              <div style={{ minWidth:0 }}>
                <div style={{ fontSize:10, color:P.textXs, fontFamily:FF, marginBottom:4 }}>Fecha de compra</div>
                <input
                  type="date"
                  value={draft.fechaCompra}
                  min={hace24}
                  max={hoyISO}
                  onChange={e=>setDraft({...draft,fechaCompra:e.target.value})}
                  style={{ ...inputBase, background:P.surface, fontSize:12, maxWidth:"100%", WebkitAppearance:"none", appearance:"none" }}
                />
              </div>
            </div>
            <div>
              <div style={{ fontSize:10, color:P.textXs, fontFamily:FF, marginBottom:6 }}>Número de meses</div>
              <div style={{ display:"flex", gap:6, flexWrap:"wrap" }}>
                {[3,6,9,12,18,24].map(m=>(
                  <button key={m} onClick={()=>setDraft({...draft,meses:m})}
                    style={{ padding:"7px 14px", borderRadius:10, cursor:"pointer", fontFamily:FF, fontSize:12, fontWeight:draft.meses===m?800:500,
                      border:`1.5px solid ${draft.meses===m?P.fijos.base:P.border}`,
                      background:draft.meses===m?P.fijos.pastel:P.surface, color:draft.meses===m?P.fijos.text:P.textSm }}>
                    {m} meses
                  </button>
                ))}
              </div>
            </div>
            {draftCuota > 0 && (
              <div style={{ marginTop:10, padding:"8px 12px", background:"rgba(108,127,232,0.08)", borderRadius:10, fontSize:12, fontFamily:FF, border:`1.5px solid ${P.fijos.tint}` }}>
                <span style={{ color:P.textSm }}>Cuota mensual: </span>
                <span style={{ fontWeight:900, fontSize:15, color:P.fijos.text }}>{fmt(draftCuota)}</span>
                <span style={{ color:P.textXs }}> por {draft.meses} meses{(() => {
                  if (!draft.fechaCompra) return "";
                  const f = new Date(draft.fechaCompra + "T00:00:00");
                  const finAbs = f.getFullYear()*12 + f.getMonth() + Number(draft.meses) - 1;
                  const finMes = finAbs % 12, finAnio = Math.floor(finAbs/12);
                  return ` · hasta ${MESES[finMes]} ${finAnio !== new Date().getFullYear() ? finAnio : ""}`.trimEnd();
                })()}</span>
              </div>
            )}
            <div style={{ display:"flex", gap:8, marginTop:12 }}>
              <button onClick={addCompra} style={{ padding:"9px 20px", borderRadius:12, cursor:"pointer", fontFamily:FF, fontSize:13, fontWeight:700, border:"none", background:P.fijos.base, color:"#fff" }}>Registrar compra</button>
              <button onClick={()=>setShowForm(false)} style={{ padding:"9px 14px", borderRadius:12, cursor:"pointer", fontFamily:FF, fontSize:12, fontWeight:500, border:`1.5px solid ${P.border}`, background:"transparent", color:P.textSm }}>Cancelar</button>
            </div>
          </div>
        ) : (
          <button onClick={()=>setShowForm(true)} style={{ border:`1.5px dashed ${P.fijos.tint}`, borderRadius:10, background:"transparent", color:P.fijos.text, cursor:"pointer", padding:"7px 16px", fontSize:12, fontFamily:FF, fontWeight:600 }}>
            + Registrar compra a meses
          </button>
        )}
      </div>
    </div>
  );
}
